<template>
  <div>
    <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" />
    <div id="app">
      <div class="card-box margin-top-12" v-if="bankInfo && bankInfo.account_number">
        <div style="color: #555555; " class="font-16">
          Credit card number
        </div>
        <div class="font-28 margin-top-16" style="text-align: right;">
          {{ bankInfo.account_number }}
        </div>
        <div class="flex flex-justify-end margin-top-12 flex-align-center">
          <img src="https://imgs.hdjfg.com/gift/img/bank.png" style="width:35px;height: 35px;" />
          <div class="font-14 " style="text-align: right;color: #333333;">
            {{ bankInfo.bank_name }}-{{ bankInfo.branch_bank }}
          </div>
        </div>
      </div>
      <div class="upload-box" v-else>
        <img src="https://imgs.hdjfg.com/gift/img/bank.png" style="width:84px;height: 84px;" class="header" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      bankInfo: null
    }
  },
  created() {
    this.getMyBankInfo()
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    async getMyBankInfo() {
      const { data: res } = await this.$http.post('/api/user/myBankInfo')
      if (res.code === 0) {
        this.bankInfo = res.data
      } else {
        this.$toast(res.msg)
      }
    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: #F9F9F9;
  min-height: 100vh;
  padding: 12px 12px 0px 12px;
  box-sizing: border-box;

  .upload-box {
    background: #FFF1EA;
    padding: 32px 134px;
    border-radius: 14px;
  }

  .card-box {
    background: #FFF1EA;
    padding: 14px;
    border-radius: 14px;
  }
}
</style>
